import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';

import Hubspot from '../../Admin/Hubspot';
import Link from '../../../Core/Link';

import {
  Wrapper,
  StyledContainer,
  ImageWrapper,
  OptionalImage,
  Content,
  TitleWrapper,
} from './styles';

const PremiumBanner = ({ sectionId, data, className }) => {
  if (!data) return null;
  const {
    headingHtml,
    subheadingHtml,
    buttonType,
    bannerCTAText,
    bannerCTA: { url: href },
    image,
    imageSharp,
    component,
    imageBackground,
    colourOverrideBackground,
    bodycopyHtml,
    formId,
    queryString,
    ariaLabel,
    textBelowButtonHtml,
    lang,
  } = data;

  const style = component
    ? component
        .toLowerCase()
        .split(' ')
        .join('-')
    : '';

  /* Lifecycle function that injects prefinery popup when using the prefinery cta, on component mount for the first time */
  useEffect(() => {
    if (
      buttonType === 'prefinery' &&
      !document.getElementById('prefinery_js')
    ) {
      // script tag with code inside
      const prefineryScript = document.createElement('script');
      prefineryScript.text = `{prefinery=window.prefinery||function()
    {(window.prefinery.q = window.prefinery.q || []).push(arguments)};
      document.body.appendChild(prefineryScript)}`;

      // script tag with js to load from url
      const prefineryJs = document.createElement('script');
      prefineryJs.src = 'https://widget.prefinery.com/widget/v2/pp6us4ef.js';
      prefineryJs.id = 'prefinery_js';
      document.body.appendChild(prefineryJs);

      // script tag to close prefinery modal by clicking outside of it, provided by prefinery team and modified to work
      const prefineryClose = document.createElement('script');
      prefineryClose.text = `document.addEventListener("click", (evt) => {
                    const popupModal = document.getElementById("prefinery_popup");
                    const popupOverlay = document.getElementById("prefinery_overlay");
                    let targetElement = evt.target;
                
                    do {
                        if (targetElement == popupModal) {
                            return;
                        }
                        targetElement = targetElement.parentNode;
                    } while (targetElement);
                    if(popupOverlay){
                      popupOverlay.style.display = "none";
                    }
                });`;
      document.body.appendChild(prefineryClose);
    }
  }, []);

  return (
    <Wrapper
      id={sectionId}
      className={[
        className,
        style,
        imageBackground && imageBackground.url ? 'bgimage' : null,
      ]}
      imageBackground={imageBackground}
      colourOverrideBackground={colourOverrideBackground}
    >
      <StyledContainer className="auto-margin">
        <Content>
          <TitleWrapper>
            {ReactHtmlParser(headingHtml)}
            {ReactHtmlParser(subheadingHtml)}
          </TitleWrapper>
          {ReactHtmlParser(bodycopyHtml)}
          {formId ? (
            <Hubspot
              uuid={formId}
              data={bannerCTAText}
              className={buttonType}
            />
          ) : (
            bannerCTAText && (
              <Link
                className={`${
                  buttonType === 'prefinery'
                    ? 'solid-on-dark-bg prefinery-form-cta'
                    : buttonType
                }`}
                to={href}
                queryString={queryString}
                ariaLabel={ariaLabel}
                lang={lang}
              >
                {bannerCTAText}
              </Link>
            )
          )}
          {ReactHtmlParser(textBelowButtonHtml)}
        </Content>
        {image.url && imageSharp && (
          <ImageWrapper>
            <OptionalImage
              src={imageSharp}
              alt={image.altTag}
              objectFit="cover"
            />
          </ImageWrapper>
        )}
      </StyledContainer>
    </Wrapper>
  );
};

PremiumBanner.propTypes = {
  data: PropTypes.shape().isRequired,
  sectionId: PropTypes.string.isRequired,
  className: PropTypes.string,
  component: PropTypes.string,
};

PremiumBanner.defaultProps = {
  className: null,
  component: null,
};

export default PremiumBanner;
